import { CommitmentsScenariosVariantsService } from '@festina/life-general-types/life/services/CommitmentsScenariosVariantsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

type Props = {
  tenantId: string
  ownerId: string
}

const method =
  CommitmentsScenariosVariantsService.commitmentScenarioVariantVersionServiceDeleteDeleteEntity
type MethodParam = Parameters<typeof method>[0]

export const useDeleteScenarioVariant = ({ tenantId, ownerId }: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      CommitmentsScenariosVariantsService.commitmentScenarioVariantVersionServiceDeleteDeleteEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'ownerId' | 'xTenantId'>) =>
      await method({
        xTenantId: tenantId,
        ownerId,
        ...arg,
      }),
  })
